import React, { Component, Fragment } from 'react';
import AddressUpdatePanel from './AddressUpdatePanel';
import NewAddressPanel from './NewAddressPanel';

export default class UserAddressPanel extends Component {
    constructor(props) {
        super(props);
        let starterAddress = ((this.props.tmpAddress.id && this.props.tmpAddress.id != -99) ? this.props.tmpAddress : (this.props.addresses && this.props.addresses.length > 0) ? this.props.addresses[0] : {address: '', address2: '', city: '', state: '', zip: '', display_name: '', delivery_instructions: ''});
        this.state = {
            showNewAddress: !this.props.addresses || this.props.addresses.length < 1, //If either no addresses, or addresses less than 1
            selectedAddress: starterAddress,
            address: starterAddress.address,
            address2: starterAddress.address2,
            city: starterAddress.city,
            state: starterAddress.state,
            zip: starterAddress.zip,
            displayName: this.props.tmpAddress.display_name ?  this.props.tmpAddress.display_name : '',
            deliveryInstructions: this.props.tmpAddress.delivery_instructions ?  this.props.tmpAddress.delivery_instructions : ''
        };
        this.setNewAddress = this.setNewAddress.bind(this);
        this.pickOldAddress = this.pickOldAddress.bind(this);
        this.updateSelectedAddress = this.updateSelectedAddress.bind(this);
        this.handleChangeToAddress = this.handleChangeToAddress.bind(this);
        this.handleChangeToAddress2 = this.handleChangeToAddress2.bind(this);
        this.handleChangeToCity = this.handleChangeToCity.bind(this);
        this.handleChangeToState = this.handleChangeToState.bind(this);
        this.handleChangeToZip = this.handleChangeToZip.bind(this);
        this.handleChangeToFirstName = this.handleChangeToFirstName.bind(this);
        this.handleChangeToLastName = this.handleChangeToLastName.bind(this);
        this.handleChangeToEmail = this.handleChangeToEmail.bind(this);
        this.handleChangeToPhone = this.handleChangeToPhone.bind(this);
        this.handleChangeToDeliveryInstructions = this.handleChangeToDeliveryInstructions.bind(this);
        this.handleChangeToDisplayName = this.handleChangeToDisplayName.bind(this);
        this.proceedWithNew = this.proceedWithNew.bind(this);
        this.clearAddress = this.clearAddress.bind(this);
    }

    clearAddress() {
        this.setState({
            address: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            displayName: '',
            deliveryInstructions: ''
        });
    }

    updateSelectedAddress(addr) {
        this.setState({selectedAddress: addr, showNewAddress: false}, ()=> {
            this.props.setAddressID(addr.id);
        });
    }

    setNewAddress() {
        this.setState({showNewAddress: true, selectedAddress: this.props.tmpAddress}, () => {
            this.clearAddress();
        });
    }

    pickOldAddress(address) {
        this.setState({showNewAddress: false, selectedAddress: address, address: address.address,
        address2: address.address2, city: address.city, state: address.state, zip: address.zip,
        deliveryInstructions: address.delivery_instructions, displayName: address.display_name
    });
    }


    handleChangeToAddress(e) {
        this.setState({address: e.target.value});
    }

    handleChangeToAddress2(e) {
        this.setState({address2: e.target.value});
    }

    handleChangeToCity(e) {
        this.setState({city: e.target.value});
    }

    handleChangeToState(e) {
        this.setState({state: e.target.value});
    }

    handleChangeToZip(e) {
        this.setState({zip: e.target.value});
    }

    handleChangeToFirstName(e) {
        this.setState({firstName: e.target.value});
    }

    handleChangeToLastName(e) {
        this.setState({lastName: e.target.value});
    }

    handleChangeToPhone(e) {
        this.setState({phone: e.target.value});
    }

    handleChangeToEmail(e) {
        this.setState({email: e.target.value});
    }

    handleChangeToDeliveryInstructions(e) {
        this.setState({deliveryInstructions: e.target.value});
    }

    handleChangeToDisplayName(e) {
        this.setState({displayName: e.target.value});
    }


    handleChangeToAddress(e) {
        this.setState({address: e.target.value});
    }

    handleChangeToAddress2(e) {
        this.setState({address2: e.target.value});
    }

    handleChangeToCity(e) {
        this.setState({city: e.target.value});
    }

    handleChangeToState(val) {
        this.setState({state: val});
    }

    handleChangeToZip(e) {
        this.setState({zip: e.target.value});
    }

    handleChangeToFirstName(e) {
        this.setState({firstName: e.target.value});
    }

    handleChangeToLastName(e) {
        this.setState({lastName: e.target.value});
    }

    handleChangeToPhone(e) {
        this.setState({phone: e.target.value});
    }

    handleChangeToEmail(e) {
        this.setState({email: e.target.value});
    }

    handleChangeToDeliveryInstructions(e) {
        this.setState({deliveryInstructions: e.target.value});
    }

    handleChangeToDisplayName(e) {
        this.setState({displayName: e.target.value});
    }

    proceedWithNew(value) {
        this.setState(
            {
                selectedAddress: value,
                address: value.address,
                address2: value.address2,
                city: value.city,
                state: value.state,
                zip: value.zip,
                deliveryInstructions: value.delivery_instructions,
                displayName:
                value.display_name
            }, ()=> {
            this.props.proceedFunction(value);
        });
    }

    render() {
        let addressList =(this.props.addresses && this.props.addresses.length > 0 )? this.props.addresses.map( (val, ind, arr) => {
            let displayName = val.display_name ? val.display_name : `Address ${ind + 1}`;
            let selectionFunction = () => {
                this.pickOldAddress(val);
            };
            let highlightClass = (this.state.selectedAddress.id === val.id && !this.state.showNewAddress) ? 'store-fg-primary' : '';
            let chevronDirection = (this.state.selectedAddress.id === val.id && !this.state.showNewAddress) ? 'down' : 'right';
            return (
            <li onClick={selectionFunction} className='list-group-item clickable-element' key={ind}>
                <p><i className={`fas fa-home ${highlightClass}`}></i> {displayName} <i className={`fas fa-chevron-${chevronDirection} ${highlightClass}`}></i></p>
            </li>)
        }) : '';
        let newAddressClass = this.state.showNewAddress ? 'btn-primary disabled' : 'btn-primary';
        let serviceType = this.props.serviceType ? this.props.serviceType : {
            name: 'Account',

        };
        return (
            <div className='mt-5 mb-5'>
                {(this.props.addresses && this.props.addresses.length > 0) ?
                <div className='container'>
                    <ul className='col-sm list-group mt-2 mb-3 clickable-element'>
                        {addressList}
                        <li className='list-group-item clickable-element text-center' onClick={this.setNewAddress}>
                            <a className={`btn  ${newAddressClass}`}>Add New Address</a>
                        </li>
                    </ul>
                </div> : ''}
                {this.state.showNewAddress ? (
                    <NewAddressPanel
                        userType={this.props.userType}
                        tmpAddress={this.props.tmpAddress}
                        updateSelectedAddress={this.updateSelectedAddress}
                        setAddressID={this.props.setAddressID}
                        backFunction={this.props.backFunction}
                        backText={this.props.backText}
                        proceedFunction={this.proceedWithNew}
                        proceedText='Add Address'
                        serviceType={serviceType}
                        handleChangeToAddress={this.handleChangeToAddress}
                        handleChangeToAddress2={this.handleChangeToAddress2}
                        handleChangeToCity={this.handleChangeToCity}
                        handleChangeToDeliveryInstructions={this.handleChangeToDeliveryInstructions}
                        handleChangeToDisplayName={this.handleChangeToDisplayName}
                        handleChangeToEmail={this.handleChangeToEmail}
                        handleChangeToPhone={this.handleChangeToPhone}
                        handleChangeToFirstName={this.handleChangeToFirstName}
                        handleChangeToLastName={this.handleChangeToLastName}
                        handleChangeToState={this.handleChangeToState}
                        handleChangeToZip={this.handleChangeToZip}
                        address={this.state.address}
                        address2={this.state.address2}
                        city={this.state.city}
                        state={this.state.state}
                        zip={this.state.zip}
                        deliveryInstructions={this.state.deliveryInstructions}
                        displayName={this.state.displayName}
                        userInfo={this.props.userInfo} />
                ) :
                <AddressUpdatePanel handleChangeToAddress={this.handleChangeToAddress} handleChangeToAddress2={this.handleChangeToAddress2}
                handleChangeToCity={this.handleChangeToCity} handleChangeToDeliveryInstructions={this.handleChangeToDeliveryInstructions} handleChangeToDisplayName={this.handleChangeToDisplayName}
                handleChangeToEmail={this.handleChangeToEmail} handleChangeToFirstName={this.handleChangeToFirstName}
                handleChangeToLastName={this.handleChangeToLastName} handleChangeToPhone={this.handleChangeToPhone}
                handleChangeToState={this.handleChangeToState} handleChangeToZip={this.handleChangeToZip}
                address={this.state.address} address2={this.state.address2} city={this.state.city} state={this.state.state}
                zip={this.state.zip} deliveryInstructions={this.state.deliveryInstructions} displayName={this.state.displayName}
                setAddressID={this.props.setAddressID} backFunction={this.props.backFunction} proceedFunction={this.props.proceedFunction} backText={this.props.backText} proceedText={this.props.proceedText} tmpAddress={this.state.selectedAddress} serviceType={serviceType} userInfo={this.props.userInfo} />}
            </div>
        )
    }

}
